import { useCallback } from "react";
import { useFolderTree } from "@devowl-wp/react-folder-tree";
import { getRmlMediaBridge } from "./bridge/rmlMediaBridge.js";
import { orderUrl } from "../../backbone/attachmentSortable.js";
import { useAppTreeMountContext } from "../../contexts/appTreeMountContext.js";
import { ID_NONE, onTreeFolderSelected } from "../../integrations/defaultFolder.js";
import { useStores } from "../../store/rootStore.js";
import { addUrlParam } from "../../utils/addUrlParam.js";
import { urlParam } from "../../utils/urlParam.js";
function useBackboneFilterSelection() {
    const { treeStore } = useStores();
    const { attachmentsBrowser } = useAppTreeMountContext();
    const getBackboneFilter = useCallback(()=>{
        return attachmentsBrowser && attachmentsBrowser.toolbar.get("rml_folder");
    }, [
        attachmentsBrowser
    ]);
    return useCallback((id = treeStore.selectedId)=>{
        if (attachmentsBrowser && id !== ID_NONE) {
            setTimeout(()=>{
                const backboneFilter = getBackboneFilter();
                backboneFilter && backboneFilter.$el.val(id).change();
                attachmentsBrowser.$el.parents(".media-modal").length === 0 && attachmentsBrowser.controller.state().get("selection").reset();
                if (treeStore.foldersNeedsRefresh.indexOf(id) > -1) {
                    treeStore.removeFoldersNeedsRefresh(id);
                    getRmlMediaBridge(attachmentsBrowser)?.reloadCurrentFolder();
                }
            }, 0);
        }
    }, [
        attachmentsBrowser,
        getBackboneFilter,
        treeStore
    ]);
}
function useHandleSelect(onSelectedChange) {
    const { treeStore } = useStores();
    const { toolbarActiveButton } = useFolderTree();
    const { attachmentsBrowser } = useAppTreeMountContext();
    const handleBackboneFilterSelection = useBackboneFilterSelection();
    const handleSelect = useCallback((id)=>{
        if (toolbarActiveButton === "sort") {
            return;
        }
        const selectId = id ?? treeStore.selectedId;
        const select = treeStore.getTreeItemById(selectId, false);
        if (!select) {
            return;
        }
        const setter = (_id, $busy)=>{
            select.setter((node)=>{
                node.$busy = $busy;
            });
            treeStore.setSelected(select);
            onSelectedChange?.();
            onTreeFolderSelected(select.id);
        };
        if (attachmentsBrowser) {
            !id && attachmentsBrowser.collection.props.set({
                ignore: +new Date()
            });
            handleBackboneFilterSelection(select.id);
        } else {
            const keepParams = [
                {
                    param: "page",
                    value: urlParam("page")
                },
                {
                    param: "paged",
                    value: urlParam("paged") !== null ? 1 : null
                }
            ].filter(({ value })=>value !== null);
            let { href } = window.location;
            urlParam("orderby") === "rml" && ([href] = href.split("?"));
            for (const { param, value } of keepParams){
                href = addUrlParam(href, param, value);
            }
            select.properties && (select.contentCustomOrder === 1 || select.forceCustomOrder) && (href = orderUrl(href));
            window.location.href = addUrlParam(href, "rml_folder", select.id);
        }
        setter(select.id, !attachmentsBrowser);
    }, [
        toolbarActiveButton,
        treeStore,
        attachmentsBrowser,
        handleBackboneFilterSelection,
        onSelectedChange
    ]);
    return {
        handleSelect,
        handleBackboneFilterSelection
    };
}
export { useBackboneFilterSelection, useHandleSelect };
